/**
 * OrdoPageContainer — the app's standard page wrapper, sized to match
 * the chefs-v2 surfaces (/orders kitchen view, /shopping-list): a
 * centered `max-w-[100rem]` column with 1rem horizontal padding and
 * `pt-4 lg:pt-5` on desktop (the shared `PageContainer` defaults to
 * 80rem + 1.5rem, which made those pages read narrower/indented than
 * the chef pages). Keeps `PageContainer`'s mobile padding, bottom-nav
 * clearance, and `space-y` rhythm.
 *
 * `fullBleed` drops the width clamp + padding overrides entirely
 * (cafeteria fullscreen mode).
 */

import { cn } from '@ordo/ui/cn'
import { PageContainer, type PageContainerProps } from '@ordo/ui/page-container'

interface OrdoPageContainerProps extends Omit<PageContainerProps, 'maxWidth'> {
  /** Let content fill the viewport (e.g. cafeteria fullscreen). */
  fullBleed?: boolean
}

export function OrdoPageContainer({ fullBleed = false, className, children, ...props }: OrdoPageContainerProps) {
  return (
    <PageContainer
      maxWidth="none"
      className={cn(!fullBleed && 'mx-auto w-full max-w-[100rem] md:px-4 md:pt-4 lg:pt-5', className)}
      {...props}>
      {children}
    </PageContainer>
  )
}
